var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14529 5.80667C7.70087 5.3858 7.11206 5.15125 6.49998 5.15125C5.88789 5.15125 5.29908 5.3858 4.85466 5.80667L2.87013 7.68355C1.73263 8.71746 2.55326 10.6939 4.08888 10.6167C4.92169 10.5943 5.5981 10.1678 6.49794 10.184C7.43029 10.1678 8.12294 10.5436 8.95982 10.6167C10.469 10.6512 11.249 8.69714 10.1278 7.68355L8.14529 5.80667Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5619 3.04829C10.786 2.89595 10.1928 3.75923 10.0385 4.50267C9.57533 6.80407 11.8056 7.24282 12.3277 5.01048C12.541 4.05376 12.2038 3.19048 11.5619 3.04829Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27323 4.2914C9.04511 4.2914 9.67277 3.4139 9.67277 2.33734C9.59558 -0.254536 6.95089 -0.254536 6.87573 2.33734C6.87573 3.4139 7.50339 4.2914 8.27323 4.2914Z",
    fill: "#787878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96146 4.50266C2.80911 3.75923 2.21396 2.89595 1.43802 3.04829C-0.000104964 3.41188 0.60927 6.47704 2.0149 6.48516C2.81115 6.45876 3.1788 5.53454 2.96146 4.50266Z",
    fill: "#787878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72668 4.2914C5.49653 4.2914 6.12418 3.4139 6.12418 2.33734C6.04903 -0.254536 3.40434 -0.254536 3.32715 2.33734C3.32715 3.4139 3.95481 4.2914 4.72668 4.2914Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPets);
export default __webpack_public_path__ + "static/media/Pets.5ea2764ab001bca06d14a0d613204529.svg";
export { ForwardRef as ReactComponent };